import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import { InvoicePageParam } from '../../api/orderManage'
import {
  AllowPaymentItem,
  GET_ALLOW_PAYMENT_PAGE,
  POST_PRECHECK,
} from '../../api/paymentOrder'
import { history } from '../../redux/store'
import {
  allElementsEqual,
  formatTime,
  isResponseCodeSuccess,
} from '../../tools/util'
import { accountOpenInvoiceStateDictInvert } from '../../tools/state'
import reducer, {
  initialState,
  setDataSourceAction,
  setIsTableLoadingAction,
  setPaginationOptionAction,
  setSelectedRowsAction,
} from './reducer'

export const handleJumpAddPayment = (record: AllowPaymentItem) => {
  history.push('/srm/addpaymentrequest', {
    data: [record],
  })
}

const useSetupHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { paginationOption, selectedRows } = state

  const handlePaginationChange = async (page: number, pageSize?: number) => {
    await getPageData({
      pageNo: page,
      pageSize: pageSize ? pageSize : paginationOption.pagesize,
    })
  }

  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  const getPageData = async (params: InvoicePageParam) => {
    const {
      pageNo = paginationOption.current,
      pageSize = paginationOption.pagesize,
    } = params
    dispatch(setIsTableLoadingAction(true))
    const res = await GET_ALLOW_PAYMENT_PAGE({
      ...params,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDataSourceAction(convertTableState(res.data.content)))
      dispatch(
        setPaginationOptionAction({
          pagesize: pageSize,
          current: pageNo,
          total: res.data.totalCount,
        }),
      )
    }
    dispatch(setIsTableLoadingAction(false))
  }

  const handleSearchClick = (value: any) => {
    getPageData({
      pageNo: 1,
      pageSize: paginationOption.pagesize,
      ...value,
    })
  }

  const convertTableState = (dataSource: AllowPaymentItem[]) =>
    dataSource.map((item) => ({
      ...item,
      orderState: '已完成',
      returnState: '已完成',
      accountOpenInvoiceStatus:
        accountOpenInvoiceStateDictInvert?.[item.accountOpenInvoiceStatus]
          ?.name ?? '',
      orderTime: formatTime(item.orderTime),
    }))

  const handleBatchRecord = async () => {
    // const filterEmpty = selectedRows.filter(
    //   (item) => item.paymentMethodList?.length !== 0,
    // )
    // const paymentMethodLists = filterEmpty.map((item) =>
    //   JSON.stringify(item.paymentMethodList),
    // )
    // const invalidOrders = selectedRows.filter(
    //   (item) => item.paymentMethodList?.length > 1,
    // )

    // const filterReject = selectedRows.filter(
    //   (item) => item.returnState === '驳回',
    // )

    if (selectedRows.length < 1) {
      message.warning('请先勾选需要付款的订单')
      return
    }
    if (
      !allElementsEqual(selectedRows.map((item) => item.titleOfTheContract))
    ) {
      message.warn('不同签约抬头的发票不能批量申请付款')
      return
    }
    if (!allElementsEqual(selectedRows.map((item) => item.platform))) {
      message.warn('不能勾选不同下单平台的订单进行批量付款')
      return
    }

    // if (invalidOrders?.length > 0) {
    //   invalidOrders.map((item) => {
    //     const orderNumber = item.orderNo
    //     const orderPerson = item.defaultPurchase
    //     message.error(
    //       `${orderNumber}订单的客户汇款存在1种以上的客户回款方式，请联系${orderPerson}后台处理付款`,
    //     )
    //   })
    //   return
    // }

    // if (new Set(paymentMethodLists)?.size > 1) {
    //   message.error('不同回款方式的订单不能一起提交，请重新申请')
    //   return
    // }

    // if (filterReject?.length > 1) {
    //   filterReject.map((item) => {
    //     const orderNumber = item.orderNo
    //     message.error(`${orderNumber}订单存在驳回的付款申请，请去处理`)
    //   })
    //   return
    // }
    const orderIds = selectedRows.map((item) => item.id)
    const res = await POST_PRECHECK({ orderIds })
    if (res.code === 0) {
      history.push('/srm/addpaymentrequest', {
        data: selectedRows,
      })
    }
  }

  const handleJump = async (record: AllowPaymentItem) => {
    const res = await POST_PRECHECK({ orderIds: [record.id] })
    if (res.code === 0) {
      history.push('/srm/addpaymentrequest', {
        data: [record],
      })
    }
  }

  useEffect(() => {
    getPageData({
      pageNo: initialState.paginationOption.current,
      pageSize: initialState.paginationOption.pagesize,
    })
    // eslint-disable-next-line
  }, [])

  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    handleJump,
  }
}
export default useSetupHook
import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import { InvoicePageParam } from '../../api/orderManage'
import {
  AllowPaymentItem,
  GET_ALLOW_PAYMENT_PAGE,
  POST_PRECHECK,
} from '../../api/paymentOrder'
import { history } from '../../redux/store'
import {
  allElementsEqual,
  formatTime,
  isResponseCodeSuccess,
} from '../../tools/util'
import { accountOpenInvoiceStateDictInvert } from '../../tools/state'
import reducer, {
  initialState,
  setDataSourceAction,
  setIsTableLoadingAction,
  setPaginationOptionAction,
  setSelectedRowsAction,
} from './reducer'

export const handleJumpAddPayment = (record: AllowPaymentItem) => {
  history.push('/srm/addpaymentrequest', {
    data: [record],
  })
}

const useSetupHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { paginationOption, selectedRows } = state

  const handlePaginationChange = async (page: number, pageSize?: number) => {
    await getPageData({
      pageNo: page,
      pageSize: pageSize ? pageSize : paginationOption.pagesize,
    })
  }

  const handleTableChangeCheck = (
    selectedRowKeys: any,
    selectedRows: any[],
  ) => {
    dispatch(setSelectedRowsAction(selectedRows))
  }

  const getPageData = async (params: InvoicePageParam) => {
    const {
      pageNo = paginationOption.current,
      pageSize = paginationOption.pagesize,
    } = params
    dispatch(setIsTableLoadingAction(true))
    const res = await GET_ALLOW_PAYMENT_PAGE({
      ...params,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDataSourceAction(convertTableState(res.data.content)))
      dispatch(
        setPaginationOptionAction({
          pagesize: pageSize,
          current: pageNo,
          total: res.data.totalCount,
        }),
      )
    }
    dispatch(setIsTableLoadingAction(false))
  }

  const handleSearchClick = (value: any) => {
    getPageData({
      pageNo: 1,
      pageSize: paginationOption.pagesize,
      ...value,
    })
  }

  const convertTableState = (dataSource: AllowPaymentItem[]) =>
    dataSource.map((item) => ({
      ...item,
      orderState: '已完成',
      returnState: '已完成',
      accountOpenInvoiceStatus:
        accountOpenInvoiceStateDictInvert?.[item.accountOpenInvoiceStatus]
          ?.name ?? '',
      orderTime: formatTime(item.orderTime),
    }))

  const handleBatchRecord = async () => {
    // const filterEmpty = selectedRows.filter(
    //   (item) => item.paymentMethodList?.length !== 0,
    // )
    // const paymentMethodLists = filterEmpty.map((item) =>
    //   JSON.stringify(item.paymentMethodList),
    // )
    // const invalidOrders = selectedRows.filter(
    //   (item) => item.paymentMethodList?.length > 1,
    // )

    // const filterReject = selectedRows.filter(
    //   (item) => item.returnState === '驳回',
    // )

    if (selectedRows.length < 1) {
      message.warning('请先勾选需要付款的订单')
      return
    }
    if (
      !allElementsEqual(selectedRows.map((item) => item.titleOfTheContract))
    ) {
      message.warn('不同签约抬头的发票不能批量申请付款')
      return
    }
    if (!allElementsEqual(selectedRows.map((item) => item.platform))) {
      message.warn('不能勾选不同下单平台的订单进行批量付款')
      return
    }

    // if (invalidOrders?.length > 0) {
    //   invalidOrders.map((item) => {
    //     const orderNumber = item.orderNo
    //     const orderPerson = item.defaultPurchase
    //     message.error(
    //       `${orderNumber}订单的客户汇款存在1种以上的客户回款方式，请联系${orderPerson}后台处理付款`,
    //     )
    //   })
    //   return
    // }

    // if (new Set(paymentMethodLists)?.size > 1) {
    //   message.error('不同回款方式的订单不能一起提交，请重新申请')
    //   return
    // }

    // if (filterReject?.length > 1) {
    //   filterReject.map((item) => {
    //     const orderNumber = item.orderNo
    //     message.error(`${orderNumber}订单存在驳回的付款申请，请去处理`)
    //   })
    //   return
    // }
    const orderIds = selectedRows.map((item) => item.id)
    const res = await POST_PRECHECK({ orderIds })
    if (res.code === 0) {
      history.push('/srm/addpaymentrequest', {
        data: selectedRows,
      })
    }
  }

  const handleJump = async (record: AllowPaymentItem) => {
    const res = await POST_PRECHECK({ orderIds: [record.id] })
    if (res.code === 0) {
      history.push('/srm/addpaymentrequest', {
        data: [record],
      })
    }
  }

  useEffect(() => {
    getPageData({
      pageNo: initialState.paginationOption.current,
      pageSize: initialState.paginationOption.pagesize,
    })
    // eslint-disable-next-line
  }, [])

  return {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    handleJump,
  }
}
export default useSetupHook
